import Component from './Close.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionClose', Component);
  },
};
